import { render, staticRenderFns } from "./Page9.vue?vue&type=template&id=fc2379a8&scoped=true&"
import script from "./Page9.vue?vue&type=script&lang=js&"
export * from "./Page9.vue?vue&type=script&lang=js&"
import style0 from "./Page9.vue?vue&type=style&index=0&id=fc2379a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2379a8",
  null
  
)

export default component.exports